import React from 'react';
import classnames from 'classnames';
import Icon from '../../components/icon';
import styles from './style.less';

interface HeaderProps {
  title: string;
  extra?: React.ReactNode;
  closeDisibled?: boolean;
  onClose(): void;
}

const Header: React.SFC<HeaderProps> = ({ title, extra, closeDisibled, onClose }) => {

  return (
    <div className={styles.header}>
      <div className={styles.titleWrapper}>
        <span className={styles.title}>{title}</span>
        { extra }
      </div>
      <div
        className={classnames(styles.headerClose, {
          [styles.headerCloseDisabled]: closeDisibled
        })}
        onClick={onClose}
      >
        <Icon type="close" color="#fff" />
      </div>
    </div>
  );
}

export default Header;
